export default __webpack_public_path__ + "99f79c717a43017aa3c04b171b93a794.svg";